import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { last } from 'rxjs/operators';
import { LayoutTableComponent } from './layout-table.component';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSelect, MatSelectModule } from '@angular/material/select';
import { ComponentsModule } from 'projects/access-control/src/app/UI/components/component.module';
import { CommonsModule } from '../commons.module';

@NgModule({
	declarations: [LayoutTableComponent],
	imports: [
		CommonModule,
		MatIconModule,
		ReactiveFormsModule,
		FormsModule,
		MatSelectModule,
		ComponentsModule,
		CommonsModule,
	],
	exports: [LayoutTableComponent],
})
export class LayoutTableModule {}
